import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ApiTypes, FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';
import { M040C040PromotionBannerComponent } from '../m040-c040-promotion-banner/m040-c040-promotion-banner.component';

@Component({
    selector: 'ui-m040-c150-highlight-banner',
    standalone: true,
    imports: [M040C040PromotionBannerComponent, RouterLinkDirective, FootnotesPipe, TrackingDirective],
    templateUrl: './m040-c150-highlight-banner.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M040C150HighlightBannerComponent {
    dealer = input.required<ApiTypes.Dealer>();
}
